/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./EventGroupActions',
	'../../../../app/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], function(_, EventGroupActions, stringResources, ContentActionsProviderAPI) {

	class LinkEventGroupAction extends EventGroupActions {
		constructor({ features }) {
			super({ features: features });
			features.ContentActions.registerProvider('linkFilterGroup', this.getAPI());
		}

		getContentActionList(idList) {
			if (this._isAvailable(idList)) {
				return [{
					name: 'linkFilterGroup',
					label: stringResources.get('toolbarActionLinkFilterGroup'),
					icon: this._features['Icons'].getIcon('link').id,
					type: 'DropDown',
					section: ContentActionsProviderAPI.ACTION_SECTION.DASHBOARD,
					order: 50,
					className: 'linkFilterGroup',
					view: {
						state: {
							idList: idList
						}
					},
					actions: {
						apply: this._execute.bind(this),
						getMenuItems: this._getGroups.bind(this)
					},
					disabled: this._isDisabled.bind(this, idList)
				}];
			} else {
				return [];
			}
		}

		_execute(groupId, idList) {
			this._features['EventGroups'].addToGroup(groupId, idList);
		}

		_isDisabled(idList) {
			if (this._isStaticWidget(idList)) {
				return true;
			}
			if(this.getNumberOfGroups(idList) < 2){
				return true;
			}
			return false;
		}

		_getGroups(idList) {
			if (this._isStaticWidget(idList)) {
				return [];
			}
			let pageid = this._getPageId(idList);
			let groups = this._features['EventGroups'].getGroupIdsOnPage(pageid);
			/*
			 * return the array of group ids for the "add to group" function. If the selection contains only 1 distinct group,
			 * then that group index should not be in the list of possible groups to be added to.
			 */
			let distinctGroupIdsInSelection = this._getDistinctGroupIdsInSelection(idList);
			//remove the group id from the list if the selection only contains 1 distinct group
			if (distinctGroupIdsInSelection.length === 1){
				groups = groups.filter(function(value) {
					return (value !== distinctGroupIdsInSelection[0]);
				});
			}
			return groups.map(group => ({ text: group.split(':')[1], itemId: group }));
		}
	}
	return LinkEventGroupAction;
});
